// @flow
import { createSelector } from "reselect";
import { getWidgetConfig } from "root/selectors";
import {
	getTabContext,
	selectTabIsIdSelected,
	selectTabContextItems,
	selectTabReachedMaxSelectionWithContext,
	selectTabCurrentContext,
	selectTabMultipleIdsInRange,
	selectTabAvailableUntilMax,
} from "../../common/selectors";
import { selectBatchStartCounter } from "../../../root/selectors";

const TAB = "facebook";

const getFacebookContext = getTabContext(TAB);
const selectIsIdSelected = selectTabIsIdSelected(TAB);
const selectContextItems = selectTabContextItems(TAB);
const selectReachedMaxSelection = selectTabReachedMaxSelectionWithContext(TAB);
const selectCurrentContext = selectTabCurrentContext(TAB);
const selectMultipleIdsInRange = selectTabMultipleIdsInRange(TAB);
const selectAvailableUntilMax = selectTabAvailableUntilMax(TAB);

const selectTabData: Object => Object = createSelector(
	(state: Object) => ({
		widgetConfig: state.widgetConfig,
		fbData: {
			auth: state.facebook.auth,
			user: state.facebook.user,
			currentContext: getFacebookContext(state).context,
			album: state.facebook.albumData,
		},
	}),
	selectBatchStartCounter,
	({ widgetConfig, fbData }, batchStartCounter) => ({
		isMultiple: widgetConfig.multiple,
		auth: fbData.auth,
		currentContext: fbData.currentContext,
		userName: (fbData.user ? fbData.user.name : ""),
		album: fbData.album,
		batchStartCounter,
	}),
);

const selectAuthData: Object => Object = createSelector(
	(state: Object) => state.facebook.auth,
	(auth) => ({ auth }),
);

const selectExtFacebookAppId: Object => string = createSelector(
	getWidgetConfig,
	(config) => config.facebookAppId,
);

export {
	selectTabData,
	selectAuthData,
	selectContextItems,
	selectIsIdSelected,
	selectReachedMaxSelection,
	selectCurrentContext,
	selectMultipleIdsInRange,
	selectAvailableUntilMax,
	selectExtFacebookAppId,
};
